/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDirectoryReviewSettingsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetDirectoryReviewSettingsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetDirectoryReviewSettingsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDirectoryReviewSettingsSecurity$outboundSchema: z.ZodMiniType<
  GetDirectoryReviewSettingsSecurity$Outbound,
  GetDirectoryReviewSettingsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getDirectoryReviewSettingsSecurityToJSON(
  getDirectoryReviewSettingsSecurity: GetDirectoryReviewSettingsSecurity,
): string {
  return JSON.stringify(
    GetDirectoryReviewSettingsSecurity$outboundSchema.parse(
      getDirectoryReviewSettingsSecurity,
    ),
  );
}

/** @internal */
export type GetDirectoryReviewSettingsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDirectoryReviewSettingsRequest$outboundSchema: z.ZodMiniType<
  GetDirectoryReviewSettingsRequest$Outbound,
  GetDirectoryReviewSettingsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function getDirectoryReviewSettingsRequestToJSON(
  getDirectoryReviewSettingsRequest: GetDirectoryReviewSettingsRequest,
): string {
  return JSON.stringify(
    GetDirectoryReviewSettingsRequest$outboundSchema.parse(
      getDirectoryReviewSettingsRequest,
    ),
  );
}
